import './PreventiveIssueDetailsFooter.scss';

import { useDispatch } from "react-redux";

import { openModal } from "../../../../../slices/modalSlice";

import { Button } from "../../../../../common-components/Buttons/Buttons";

import PreventiveIssueDetailsModal from "../PreventiveIssueDetailsModal/PreventiveIssueDetailsModal";

const PreventiveIssueDetailsFooter = ({id}) => {
    const dispatch = useDispatch();

    const handleOpen = () => {
        dispatch(openModal({content: <PreventiveIssueDetailsModal id={id}/>, closeable: true}));
    }

    return (
        <div className={"preventive-issue-details-footer"}>
            <Button title={"Закрыть нарушение"} onClick={handleOpen}/>
        </div>
    )
}

export default PreventiveIssueDetailsFooter;

